import type { GetGameAvailabilityRequest } from '@patrianna/shared-patrianna-types/websocket/requests'
import type { GetGameAvailabilityResponse } from '@patrianna/shared-patrianna-types/websocket/response'
import { useEffect, useState } from 'react'

import ROUTES from 'config/routes.json'
import { serviceDependencies } from 'src/services'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'

export const useGameSupplierAvailable = (supplier: string) => {
  const dispatch = useAppDispatch()
  const loggedIn = useAppSelector(isLoggedInSelector)
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    if (loggedIn) {
      const data: GetGameAvailabilityRequest = {
        type: 'GetGameAvailabilityRequest',
        supplier: supplier,
      }

      serviceDependencies.gateway
        .emit<GetGameAvailabilityResponse>(data)
        .then((body) => {
          setAvailable(body.available)
        })
        .catch((err) => {
          const isOtpRequired = err?.status?.errorCode === 'err_otp_required'

          if (isOtpRequired) {
            window.location.href = ROUTES.OTP
          } else {
            dispatch(serviceDependencies.errorHandler(err, data))
          }
        })
    }
  }, [loggedIn, supplier])

  return available
}
